import request from '@/config/axios'

export const getMerchantScenicPage = (params: any) => {
  return request.get({ url: '/scenic/merchant-scenic/page', params })
}

export const getMerchantScenic = (id: number) => {
  return request.get({ url: '/scenic/merchant-scenic/get', params: { id } })
}

export const createMerchantScenic = (data: any) => {
  return request.post({ url: '/scenic/merchant-scenic/create', data })
}

export const updateMerchantScenic = (data: any) => {
  return request.put({ url: '/scenic/merchant-scenic/update', data })
}

export const auditMerchantScenic = (data: { id: number; status: number; auditRemark?: string }) => {
  return request.put({ url: '/scenic/merchant-scenic/audit', data })
}

export const deleteMerchantScenic = (id: number) => {
  return request.delete({ url: '/scenic/merchant-scenic/delete', params: { id } })
}

/** 商家下拉（名称/编码/手机可搜） */
export const getMerchantScenicMerchantOptions = (keyword?: string) => {
  return request.get<Array<{ id: number; name: string; code?: string; contactPhone?: string }>>({
    url: '/scenic/merchant-scenic/merchant-options',
    params: keyword ? { keyword } : undefined
  })
}
